export const adminAccessOptions = [
  { value: 'none', label: 'None' },
  {
    value: 'entire_acc_admin',
    label: 'Administration access for the entire account',
  },
  {
    value: 'certain_loc_admin',
    label: 'Administration access for certain locations only',
  },
];
